import { Component, Input, OnChanges, OnDestroy, SimpleChanges } from '@angular/core';
import { CasinoGameListModel, CasinoGameModel } from '@components/casino/casino.model';
import { environment } from '@environments/environment';
import { CasinoHelper } from '@components/casino/casino.helper';
import { ApiService } from '@services/api.service';
import { debounce } from 'lodash';
import { LocalizationService } from '@services/localization.service';
import { TranslateService } from '@services/translate.service';
import { Subscription } from 'rxjs';

@Component({
  selector: 'casino-image-component',
  template: `<ng-container>
    <div class="casino-card-container">
      <div *ngFor="let cardData of this.gameTypes?.gameList; trackBy: trackByProviderId" class="casino-card">
        <div class="casino-card-image-wrapper">
          <img
            [src]="cardData.image"
            alt="{{ cardData.name }}"
            class="casino-card-image"
            (click)="goGamesAction(cardData)"
            (error)="cardData.image = environment.assetsPath + 'images/shared/default-casino.png'" />
        </div>
        <div class="casino-card-title">
          {{ cardData.name }}
          <span class="card-fav" (click)="favAction($event, cardData)" [ngClass]="{ active: cardData.isFav }">
            <image-loader-utils url="star"></image-loader-utils>
          </span>
        </div>
      </div>
    </div>

    <!-- Casino Loading kapatıldı -->
    <ng-container *ngIf="this.isGameListLoading && false">
      <div class="casino-loading">
        <image-loader-utils url="logo-1" [shared]="false" extraClasses="casino-loading-icon"></image-loader-utils>
      </div>
    </ng-container>
    <ng-container *ngIf="!this.isGameListLoading && this.gameTypes?.gameList && this.gameTypes.gameList.length === 0">
      <div class="games-error-container">{{ this.isFav ? ('casino.lobby.game_not_found_fav' | translate) : ('casino.lobby.game_not_found_1' | translate) }}</div>
    </ng-container>
  </ng-container>`,
  styles: [],
})
export class CasinoImageComponent {
  @Input() gameTypes: CasinoGameListModel;
  @Input() isGameListLoading: boolean;
  @Input() isFav = false;
  isFavLoading = false;
  constructor(public _CasinoHelper: CasinoHelper, private _ApiService: ApiService, private _TranslateService: TranslateService) {}
  goGamesAction(item: CasinoGameModel): void {
    this._CasinoHelper.goGamesAction(item);
  }
  trackByProviderId(index: number, game: any): number {
    return game.id;
  }
  favAction = debounce((event: Event, cardData: any) => {
    event.stopPropagation(); // Kart tıklamasını engeller
    if (!this.isFavLoading) {
      this.isFavLoading = true;
      this._ApiService
        .casinoFavAddAndRemove({
          gameId: cardData.id,
          eventType: !cardData.isFav,
        })
        .then(() => {
          this._CasinoHelper.favChangeListener.emit();
          cardData.isFav = !cardData.isFav; // Güncellenen favori durumu
          this._CasinoHelper.snackbarWarningMessage(
            'success',
            cardData.isFav ? this._TranslateService.instant('casino.lobby.add_favorite') : this._TranslateService.instant('casino.lobby.remove_favorite')
          );
        })
        .catch(() => {
          this._CasinoHelper.snackbarWarningMessage('error', this._TranslateService.instant('casino.lobby.there_is_problem'));
        })
        .finally(() => {
          this.isFavLoading = false;
        });
    }
  }, 1000);
  protected readonly environment = environment;
  protected readonly debounce = debounce;
  protected readonly console = console;
}

@Component({
  selector: 'casino-image-util',
  template: `<ng-container>
    <img
      [id]="'dynamicImage' + cardData.id"
      [alt]="cardData.name"
      (load)="onImageLoad($event, cardData.id)"
      [errorImage]="cardData.createErrorImage(assetsPath)"
      [lazyLoad]="cardData.image"
      (onStateChange)="myCallbackFunction($event)"
      [ngStyle]="{ opacity: this.isImage ? 1 : 0 }" />
    <img
      [id]="'dynamicImage' + cardData.id"
      [alt]="cardData.name"
      class="background-image"
      [errorImage]="cardData.createErrorImage(assetsPath)"
      [defaultImage]="cardData.createDefaultImage(assetsPath)"
      [lazyLoad]="cardData.image" />
    <ng-container *ngIf="this.isLoadingSvg">
      <image-loader-utils url="logo-1" [shared]="false" extraClasses="casino-loading-svg"></image-loader-utils>
    </ng-container>
    <div *ngIf="this.failedImage" class="casino-image-failed-text">
      {{ cardData.name }}
    </div>
    <div class="card-details-container">
      <div class="card-details">
        <div class="card-details-top">
          <div class="card-title">{{ cardData.name }}</div>
        </div>
        <div class="card-details-center" (click)="this.goGamesAction(cardData)">
          <div class="card-play">{{ 'casino.lobby.play' | translate }}</div>
        </div>
        <div class="card-details-bottom">
          <div class="card-fav" (click)="this.favAction(cardData.id)" [ngClass]="this.isFav ? 'active' : ''">
            <image-loader-utils url="star"></image-loader-utils>
          </div>
        </div>
      </div>
      <div class="card-fav" (click)="this.favAction(cardData.id)" [ngClass]="this.isFav ? 'active' : ''">
        <image-loader-utils url="star"></image-loader-utils>
      </div>
    </div>
  </ng-container>`,
  styles: [],
})
export class CasinoImageUtil implements OnChanges, OnDestroy {
  @Input() cardData: CasinoGameModel;
  @Input() assetsPath: string;
  @Input() isOnLoad = true;

  public failedImage = false;
  public isLoadingSvg = false;
  public isImage = false;
  public isFav = false;
  public isFavLoading = false;
  private subscriptions: Subscription[] = [];

  constructor(public _CasinoHelper: CasinoHelper, private _TranslateService: TranslateService, private _ApiService: ApiService, private _LocalizationService: LocalizationService) {
    this.subscriptions.push(
      this._CasinoHelper.favListListener.subscribe(() => {
        this.isFav = this._CasinoHelper.favList.includes(this.cardData.id);
      })
    );
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes.cardData.currentValue) {
      this.isFav = this._CasinoHelper.favList.includes(this.cardData.id);
    }
  }

  ngOnDestroy() {
    this.favAction.cancel();
    for (const subscription of this.subscriptions) {
      if (subscription) {
        subscription.unsubscribe();
      }
    }
  }

  onImageLoad(event: any, id: string | number): void {
    if (this.isOnLoad) {
      const imgElement = event.target as HTMLImageElement;
      const imgElementContainer = document.getElementById(`casino-image-container${id}`) as HTMLImageElement;
      const width = imgElement.naturalWidth;
      const height = imgElement.naturalHeight;

      if (width >= height * 2) {
        imgElementContainer.classList.add('h-2');
      } else if (height >= width * 1.5) {
        imgElementContainer.classList.add('v-2');
      } else {
        imgElementContainer.classList.add('c-1');
      }
    }
  }

  goGamesAction(item: CasinoGameModel): void {
    this._CasinoHelper.goGamesAction(item);
  }

  favAction = debounce((gameId: number) => {
    if (!this.isFavLoading) {
      this.isFavLoading = true;
      this._ApiService
        .casinoFavAddAndRemove({
          gameId,
          eventType: !this.isFav,
        })
        .then(x => {
          this._CasinoHelper.favChangeListener.emit();
          this.isFav = !this.isFav;
          this._CasinoHelper.snackbarWarningMessage(
            'success',
            this.isFav ? this._TranslateService.instant('casino.lobby.add_favorite') : this._TranslateService.instant('casino.lobby.remove_favorite')
          );
        })
        .catch(() => {
          this._CasinoHelper.snackbarWarningMessage('error', this._TranslateService.instant('casino.lobby.there_is_problem'));
        })
        .finally(() => {
          this.isFavLoading = false;
        });
    }
  }, 1000);

  myCallbackFunction(event: any) {
    switch (event.reason) {
      case 'setup':
        // The lib has been instantiated but we have not done anything yet.
        break;
      case 'observer-emit':
        // The image observer (intersection/scroll/custom observer) has emit a value so we
        // should check if the image is in the viewport.
        // `event.data` is the event in this case.
        break;
      case 'start-loading':
        this.isLoadingSvg = true;
        break;
      case 'mount-image':
        // The image has been loaded successfully so lets put it into the DOM
        break;
      case 'loading-succeeded':
        this.isImage = true;
        break;
      case 'loading-failed':
        this.failedImage = true;
        this.isImage = true;
        break;
      case 'finally':
        this.isLoadingSvg = false;
        break;
    }
  }
}
